<template>
  <div
    :class="$style.sectionRoot"
  >
    <header
      :class="[
        $style.sectionHeader,
        $style.sectionGeneralMargin,
      ]"
    >
      Custom Identity Management
    </header>

    <p
      :class="$style.sectionGeneralMargin"
      data-test-id="description"
    >
      Set up a custom user provisioning integration. This integration will work with any
      application that supports a SCIM or custom API. Once integrated, you can import user
      accounts from this application's service provider.
      <Link
        :href="customImportKbArticleLink"
        :isExternal="true"
        target="_blank"
        text="Learn more"
      />
    </p>
    <div v-if="displayInputQuery">
      <hr :class="$style.hr">
      <ScimUsersImportSection />
    </div>
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { Link } from '@jumpcloud/ui-components';
import { mapState } from 'vuex';
import IdentityManagementMixin from 'client/applications/mixins/IdentityManagementMixin';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import ScimUsersImportSection from 'client/applications/import/ScimUsersImportSection';

const { application } = ItemTypeConsts;
const ApplicationModel = StoreModelMap[application];

export default {

  name: 'GenericScimConnectorHeader',

  components: {
    Link,
    ScimUsersImportSection,
  },

  mixins: [
    IdentityManagementMixin,
  ],

  props: {
    displayInputQuery: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapState(ApplicationModel, ['item']),

    appScimStatus() {
      if (this.isScimActive) {
        const text = (this.item.isBookmark ? this.item.displayLabel : this.item.displayName);
        return `${text} SCIM Integration Configured`;
      }
      return `${this.item.displayName} SCIM Integration Not Configured`;
    },

    customImportKbArticleLink: () => KbArticleUrls.importUsersFromCustomRestApi,

    showRevertButton() {
      return this.areCredentialsChanged || this.isGenericConnectorChanged;
    },
  },
};
</script>

<style module>
@import '../../css/sections.css';
@import './css/IdentityManagementCommon.css';

.scimManagementPanelButtonWrapper {
  display: inline;
  margin-right: 5px;
}
</style>
